import httpClient from './httpClient';

const getAmountDisplay = (body) => httpClient.post('/api/v1/Property/GetAmountDisplay', body);

const getAddOnPaxPrice = (body) => httpClient.post('/api/v1/BookingEngine/GetAddOnPaxPrice', body);


let parseExtraServiceType = function (ex) {
    let name = "";

    switch (ex) {
        case "PerBooking":
            break;
            name = "Per Booking";
        case "PerStay":

            break;
        case "PerPerson":
            break;
        case "PerNight":
            break;
    }

    return name;
}


const ex = {
    getAmountDisplay,
    getAddOnPaxPrice
}

export default ex 